import styled, { css } from 'styled-components';
import { theme } from 'styles';

const types = {
  enabled: css`
    border: 1px solid ${theme.colors.fill12};
    background-color: #ffffff;
  `,
  focused: css`
    border: 1px solid ${theme.colors.primary};
    background-color: #ffffff;
    box-shadow: ${theme.shadows.input};
  `,
  hovered: css`
    border: 1px solid ${theme.colors.gray500};
    background-color: #ffffff;
  `,
  filled: css`
    border: 1px solid ${theme.colors.gray200};
    background-color: #ffffff;
  `,
  disabled: css`
    border: 1px solid ${theme.colors.fill05};
    background-color: ${theme.colors.fill02};
    cursor: not-allowed;
  `,
  error: css`
    border: 1px solid ${theme.colors.alert};
    background-color: #ffffff;
    box-shadow: 0px 0px 0px 3px rgba(225, 44, 37, 0.2);
  `,
};

export const Label = styled.label`
  font-size: ${({ $default }) => ($default ? '16px' : '18px')};
  color: ${({ $disabled }) => ($disabled ? theme.colors.disabled : theme.colors.normal)};
  margin-bottom: 4px;
`;

export const InputField = styled.input`
  padding: ${({ $padding }) => $padding || '15px 40px 15px 12px'};
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.5;
  width: 100%;
  color: ${({ disabled }) => (disabled ? theme.colors.disabled : theme.colors.normal)};
  ${types.enabled}

  &[disabled] {
    ${types.disabled}
  }

  &[aria-invalid='true'] {
    ${types.error}
  }

  &::placeholder {
    color: ${theme.colors.supportive};
  }

  &:hover {
    ${({ disabled, $error }) => !disabled && !$error && types.hovered}
  }

  &:focus {
    ${({ disabled, $error }) => !disabled && !$error && types.focused}
    outline: none;
  }
`;

export const HelperText = styled.span`
  font-size: 14px;
  line-height: 1.5;
  color: ${theme.colors.alert};
  margin-top: 4px;
  padding: 0 8px;
`;

export const Unit = styled.span`
  display: inline-block;
  width: 24px;
  color: ${({ $disabled }) => ($disabled ? theme.colors.disabled : theme.colors.primary)};
  margin-left: -36px;
  font-size: 16px;
`;
